import { useState, useEffect, useRef } from 'react';
import IconSvg from 'src/assets/icons/IconSvg';

interface Props {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

const LeaderboardSearchInput = ({ placeholder = 'Search User', value, onChange }: Props) => {
  const [localValue, setLocalValue] = useState(value);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setLocalValue(v);

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onChange(v);
    }, 300);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <div className="relative flex-1 xl:flex-none xl:w-[408px]">
      <IconSvg
        icon="searchS"
        className="absolute left-3 top-1/2 -translate-y-1/2 text-grayscale-400"
      />
      <input
        type="text"
        className="w-full h-[40px] pl-9 pr-9 rounded-lg bg-grayscale-900 text-brand-magnolia placeholder:text-grayscale-500 outline-none text-sm"
        placeholder={placeholder}
        value={localValue}
        onChange={handleChange}
      />
      <div className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-grayscale-500 border border-grayscale-700 rounded px-1.5 py-0.5">
        /
      </div>
    </div>
  );
};

export default LeaderboardSearchInput;
